import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import React, { Component } from 'react';
import styled from 'styled-components';
import { fontSize, color, space, breakpoint } from '@core-ds/primitives';
import { Icon } from '@ifixit/toolbox';
var iconHeight = 40;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   min-width: 300px;\n   background-color: ", ";\n   border: 2px ", " solid;\n   border-radius: 4px;\n\n   @media screen and (max-width: ", ") {\n      width: 100%;\n   }\n"])), function (props) {
  return props.fill;
}, function (props) {
  return props.border;
}, breakpoint.md);
var Content = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   display: flex;\n   flex-direction: column;\n   padding: ", ";\n"])), space[5]);
var Title = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   color: ", ";\n   font-weight: 900;\n   letter-spacing: 2px;\n   font-size: ", ";\n"])), function (props) {
  return props.color;
}, fontSize.md);
var NoteText = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n   padding-top: ", ";\n   font-size: 14px;\n   color: ", ";\n"])), space[2], color.black);
var IconContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n   display: flex;\n   position: relative;\n   top: ", "px;\n   left: ", "px;\n   width: ", "px;\n   height: ", "px;\n   background-color: ", ";\n   border-radius: 50%;\n   justify-content: center;\n   align-items: center;\n   color: white;\n   border: 4px white solid;\n"])), iconHeight / 2, -iconHeight / 2, iconHeight, iconHeight, function (props) {
  return props.color;
});

var ProductNote = /*#__PURE__*/function (_Component) {
  _inherits(ProductNote, _Component);

  var _super = _createSuper(ProductNote);

  function ProductNote() {
    _classCallCheck(this, ProductNote);

    return _super.apply(this, arguments);
  }

  _createClass(ProductNote, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          title = _this$props.title,
          html = _this$props.html;
      var values = {
        note: [color.blue[50], color.blue[200], color.blue[700], color.blue[500], 'check'],
        disclaimer: [color.amber[50], color.amber[100], color.yellow[600], color.amber[400], 'alert-circle'],
        warning: [color.red[50], color.red[300], color.red[600], color.red[400], 'x']
      };
      var fill = values[type][0];
      var border = values[type][1];
      var textColor = values[type][2];
      var iconBorderColor = values[type][3];
      var iconType = values[type][4];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconContainer, {
        color: iconBorderColor
      }, /*#__PURE__*/React.createElement(Icon, {
        size: 18,
        name: iconType
      })), /*#__PURE__*/React.createElement(Container, {
        fill: fill,
        solid: true,
        border: border
      }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Title, {
        color: textColor
      }, title.toUpperCase()), /*#__PURE__*/React.createElement(NoteText, {
        dangerouslySetInnerHTML: {
          __html: html
        }
      }))));
    }
  }]);

  return ProductNote;
}(Component);

export default ProductNote;